import { IMAGES_MEDIA_PLATFORM_HOST, FILES_MEDIA_PLATFORM_HOST, MEDIA_PLATFORM_DOMAIN, WIXSTATIC_HOST, } from '@wix/wix-vod-constants/common';
import { GOOGLE_PHOTO_PATTERN, resizeGooglePhotoThumbnail, resizeYoutubeThumbnail, YOUTUBE_THUMBNAIL_PATTERN, } from './resize-youtube-thumbnails/resize-youtube-thumbnail';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
const JPEG_PARAMS = {
    q: 85,
    usm: '0.66_1.00_0.01',
    enc_auto: true,
};
export var MODES;
(function (MODES) {
    MODES["fit"] = "fit";
    MODES["fill"] = "fill";
})(MODES || (MODES = {}));
const getFullThumbnailUrl = (imageHost, relativeUrl) => `${imageHost}/${relativeUrl}`;
const isJPEG = (extension) => /^jpe?g$/i.test(extension);
const isGIF = (extension) => /^gif$/i.test(extension);
function forceSSL(url) {
    return url.replace(/^http:\/\//, 'https://');
}
const modifyUrlWithParams = (url, mode, params) => {
    return [
        ...url.split('/'),
        'v1',
        mode,
        `w_${params.w},h_${params.h},enc_auto`,
        'file.jpeg',
    ].join('/');
};
const _getResizedImageUrl = ({ url, width, height = width, params = {}, mode, imageHost = PRODUCTION_HOSTS.image, }) => {
    if (!url) {
        return '';
    }
    width = Math.round(width);
    height = Math.round(height);
    mode = mode === MODES.fit ? MODES.fit : MODES.fill;
    params = {
        ...params,
        w: width,
        h: height,
    };
    if (url.startsWith(FILES_MEDIA_PLATFORM_HOST)) {
        // TODO: Talk to BE why it saves file url host for images
        url = url.replace(FILES_MEDIA_PLATFORM_HOST, IMAGES_MEDIA_PLATFORM_HOST);
    }
    const fullFilename = url.split('/').pop();
    const imagePath = url.replace(fullFilename, '');
    const filenameSplitted = fullFilename.split('.');
    const filename = filenameSplitted.slice(0, -1).join('.');
    const ext = filenameSplitted[filenameSplitted.length - 1];
    if (url.startsWith(PRODUCTION_HOSTS.image)) {
        if (params.w && params.h && !isGIF(ext)) {
            return modifyUrlWithParams([...url.split('/').slice(0, -1)].join('/'), mode, params);
        }
        return url;
    }
    if (url.includes(MEDIA_PLATFORM_DOMAIN) || url.startsWith(WIXSTATIC_HOST)) {
        if (params.w && params.h && !isGIF(ext)) {
            return modifyUrlWithParams(url, mode, params);
        }
        return url;
    }
    if (YOUTUBE_THUMBNAIL_PATTERN.test(url)) {
        return resizeYoutubeThumbnail(url, width, height);
    }
    if (GOOGLE_PHOTO_PATTERN.test(url)) {
        return resizeGooglePhotoThumbnail(url, width, height);
    }
    if (/vimeocdn/.test(url)) {
        return url.replace(/(_\d+(x\d+)?)?\.jpg/, `_${width}x${height}.jpg`);
    }
    if (/^(https?:)?\/\//.test(url)) {
        return url;
    }
    if (/^media\//.test(url)) {
        // this workaround was done in order to get direct link to media file from non-wix-sdk environment
        return `https://static.wixstatic.com/media/${url.replace(/^media\//, '')}`;
    }
    if (isJPEG(ext)) {
        params = {
            ...params,
            ...JPEG_PARAMS,
        };
    }
    const keys = Object.keys(params);
    const imageParamsPath = keys
        .reduce((res, key) => {
        const value = params[key];
        if (typeof value === 'boolean') {
            if (value) {
                res.push(key);
            }
        }
        else {
            res.push(`${key}_${value}`);
        }
        return res;
    }, [])
        .join(',');
    if (isGIF(ext)) {
        return getFullThumbnailUrl(imageHost, `${imagePath}file`);
    }
    const fullImagePath = `${imagePath}v1/${mode}/${imageParamsPath}/${filename}.${ext}`;
    return getFullThumbnailUrl(imageHost, fullImagePath);
};
export function getResizedImageUrl(args) {
    const fullUrl = _getResizedImageUrl(args);
    return forceSSL(fullUrl);
}
//# sourceMappingURL=get-resized-image-url.js.map